import * as Factory from 'factory.ts'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  type CatalogAccessSettingsConstructor,
  CatalogAccessSettings,
} from './CatalogAccessSettings'

export const CatalogAccessSettingsConstructorFactory =
  Factory.Sync.makeFactory<CatalogAccessSettingsConstructor>({
    rfoLockDefault: false,
    catalogPermissionEnabled: false,
  })

export const CatalogAccessSettingsFactory = EntityFactory(
  CatalogAccessSettings,
  CatalogAccessSettingsConstructorFactory
)
